
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Notifications</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a routerLink="/app/dash">Home</a></li>
              <li class="breadcrumb-item active">Notifications</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-info"><i class="far fa-envelope"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Personal Notifications</span>
                <span class="info-box-number">{{infodash.percnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-success"><i class="far fa-flag"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Class Notifications</span>
                <span class="info-box-number">{{infodash.classcnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-warning"><i class="far fa-copy"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Generic Notifications</span>
                <span class="info-box-number">{{infodash.gencnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <span class="info-box-icon bg-danger"><i class="far fa-star"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Total Notifications</span>
                <span class="info-box-number">{{infodash.totcnt}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
        </div>
        <div class="row">
          <div class="col-md-9">
            <div class="card card-danger card-outline">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-bell mr-1"></i>
                Notifications
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" (click)="notifications('')">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content p-0">
                  <!-- Morris chart - Sales -->
                  <div class="row">
                    <div class="col-12">
                     
                      <div class="row">
                        <div class="col-12">
                         
                            <div class="post clearfix" *ngFor="let not of arrnotification">
                              <div class="user-block" style="margin-left:0px !important;margin-bottom:0px !important" >
                                
                                <span class="username" style="font-weight:bold;margin-left:0px !important">
                                  <a style="color:red;">{{not.cron | date: 'dd MMMM, yyyy'}} {{not.cron | date: 'h:mm a'}} {{not.cron | date: 'EEEE'}}</a>
                                </span>
                                <!-- <span class="description" style="color:red;font-size:11px;margin-left:0px !important">{{not.cron | date: 'dd MMM, yyyy'}} {{not.cron | date: 'h:mm a'}} {{not.cron | date: 'EEEE'}}</span> -->
                              </div>
                              
                              <p style="font-size:16px;margin-bottom:0px !important">
                                {{not.nfcontent}}
                              </p>
        
                              <p>
                                <span *ngFor="let link of not.links">
                                  <span class="spanlink"(click)="openlink(link.fpath)">{{link.fpath}}
    
                                  </span>
                                   &nbsp;</span>
                                <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                              </p>
    
                              <p>
                                <span *ngFor="let link of not.filelst;let i=index">
                                  <span class="badge badge-success" title="View/Download" style="cursor: pointer" (click)="openfiles(link.fpath)"><i class="fa fa-paperclip"></i>
                                    Attachment-{{i+1}}
                                  </span>
                                   &nbsp;</span>
                                <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                              </p>
                            </div>
        
                        
        
                           
                        </div>
                      </div>
    
                       
    
                       
                    </div>
                  </div>



                </div>
             
              </div><!-- /.card-body -->
              <!-- <div class="card-footer clearfix">
                <a href="#" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div> -->

            </div>
          
          </div>
          <div class="col-md-3">

        
            <!-- About Me Box -->
            <div class="card card-danger card-outline">
              <div class="card-header">
                <h3 class="card-title">Useful Links</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <strong><i class="fas  fa-lock mr-1"></i>Abacus</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>

                <hr>

                <strong><i class="fas fa-pencil-alt mr-1"></i> Vedic Maths</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>
                 <hr>
                <strong><i class="far fa-file-alt mr-1"></i> Art & Craft</strong>

                <p class="text-muted">
                  B.S. in Computer Science from the University of Tennessee at Knoxville
                </p>
               

               

              
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->